export const SALES_INVOICE_QUERY = {
  getOrderCustomer: `
    query GetOrderByCusstomer($input: OrderDataInput
        $skip: Float
        $take: Float){
            getOrderData(where:$input, skip: $skip, take: $take){
                pageInfo {
            currentPage
            hasNextPage
            hasPreviousPage
            itemsPerPage
            totalItems
            totalPages
            }
                items{
                    id
                    useYn
                    isSyncFromSap
                    customerId
                    mainOrderId
                    childCustomerId
                    mainOrderId
                    teamSalesId
                    paymentTypeId
                    createDate
                    modifyDate
                    typeDebt
                    merginPrice
                    merginRate
                    totalPrice
                    totalDiscount
                    totalProcessPrice
                    totalProductPrice
                    finalPriceSap
                    totalQ10
                    marketGoldPrice
                    orderTypeId
                    orderTypeName
                    plantId
                    marketNote
                    createName
                    modifyName
                    confMarketTime
                    totalGoldPrice
                    processId
                    orderCheckSyn
                    orderStatusSyn
                    statusId 
                    statusName
                    finalPriceSap
                    quantity
                    tRelationOrder{
                        id
                        useYn
                        customerId
                        mainOrderId
                        childCustomerId
                        mainOrderId
                        teamSalesId
                        paymentTypeId
                        createDate
                        tchildCustomer{
                            storeName
                            sapCustomerId
                        }
                        modifyDate
                        typeDebt
                        merginPrice
                        merginRate
                        totalPrice
                        totalDiscount
                        totalProcessPrice
                        totalProductPrice
                        finalPriceSap
                        totalQ10
                        marketGoldPrice
                        orderTypeId
                        orderTypeName
                        plantId
                        marketNote
                        createName
                        modifyName
                        confMarketTime
                        totalGoldPrice
                        processId
                        orderCheckSyn
                        orderStatusSyn
                        statusId 
                        statusName
                        finalPriceSap
                        quantity
                        tcustomer{
                            id
                            sapCustomerId
                            storeName
                        }
                        torderProcess{
                            id
                            processId
                            processCode
                        }
                    }
                    tchildCustomer{
                        storeName
                        sapCustomerId
                    }
                    tcustomer{
                        id
                        storeName
                        sapCustomerId
                    }
                    torderProcess{
                        id
                        processId
                        processCode
                    }
                    tOrderSeparation{
                        id
                        finalPrice
                        mainOrderId
                        statusId
                        tstatus{
                            id
                            name
                        }
                        createDate
                        orderTypeId
                        remainingYn
                    }
                }
            }
        }
    `,
};
